import { useEffect } from 'react';

type TOptions = {
  page: number;
  setPage: (page: number) => void;
  pageSize: number;
  count: number | undefined;
  hasFreshData: boolean;
};

export const useClampListPage = ({ page, setPage, pageSize, count, hasFreshData }: TOptions) => {
  useEffect(() => {
    if (!hasFreshData || count === undefined) {
      return;
    }
    const totalPages = Math.max(1, Math.ceil(count / pageSize));
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [count, hasFreshData, page, pageSize, setPage]);
};
